import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles<{ isDisabled: boolean }>()(
  (_, { isDisabled }) => ({
    tag: {
      ...dFlex(),

      '.MuiFormControlLabel-root': {
        ...dFlex(),
        gap: 16,
        margin: 0,
      },

      ...(isDisabled && {
        opacity: 0.5,
      }),
    },
    icon: {
      width: 24,
      height: 'auto',
      paddingLeft: '8px',
    },
  }),
);

export default useStyles;
